import { cn } from '@utils/helpers';
import { useMemo } from 'react';
import { useFragment } from 'react-relay';
import { Link } from 'react-router-dom';
import { infoLinkFragment } from './InfoLink.relay';
import type { InfoLinkPropsType } from './types';

const InfoLink: React.FC<InfoLinkPropsType> = (props: InfoLinkPropsType) => {
  const infoLink = useFragment(infoLinkFragment, props.infoLink);

  const { header, infotext, url, linktext, key } = infoLink;
  const target = useMemo(() => (props.openInSameTab ? null : '_blank'), [props.openInSameTab]);
  const linkUrl = useMemo(() => {
    if (key === 'publicationsservicekey') {
      // Pass only the fund identifier as the preselected search value. Strip a
      // leading language segment (e.g. "/en/") and then the leading slash. The
      // default language "de" has no path prefix, so the segment is optional and
      // non-prefixed paths are left unchanged.
      const isin = window.location.pathname.replace(/^\/(de|en|hu|cs|ru)(?=\/)/, '').replace(/^\//, '');
      return `${url}?isin=${isin}`;
    }

    return url;
  }, [url, key]);

  return (
    <div className={cn('h-full flex flex-col justify-between')}>
      <div>
        <p className="text-xs uppercase border-b border-black text-accent mb-0">{header}</p>
        <p className="mb-0 pt-1">{infotext}</p>
      </div>
      <div className="flex justify-end pt-6">
        {props.isRouterLink ? (
          <Link
            to={linkUrl}
            className="flex justify-center w-full min-w-[200px] max-w-[300px] cursor-pointer rounded-[15px] border border-black bg-white px-5 py-1.5 text-xs font-normal uppercase hover:cursor-pointer text-accent"
          >
            {linktext}
          </Link>
        ) : (
          <a
            href={linkUrl}
            className="flex justify-center w-full min-w-[200px] max-w-[300px] cursor-pointer rounded-[15px] border border-black bg-white px-5 py-1.5 text-xs font-normal uppercase hover:cursor-pointer text-accent"
            target={target}
          >
            {linktext}
          </a>
        )}
      </div>
    </div>
  );
};

export { InfoLink };
